/**
 * Module remove
 *
 * This module remove content from dom
 *
 */

'use strict';

const jQuery = require('jquery');

const Translator = require('./../../../core/translator');
const Mediator = require('./../../../core/mediator');

const ContentManager = require('./../component/ContentManager');
const PopinManager = require('./../../../services/popin');
const SaveManager = require('./../component/SaveManager');
const HighlightContent = require('./../service/highlightContent');
const DndZone = require('./../service/dndZone');
const ResizeColumn = require('./../service/resizeColumn');
const Expose = require('./../../../expose');

const tpl = require('./../template/plugin_delete.hbs');

/**
 * Remove content
 *
 * @param  {object} content
 */
module.exports.remove = function(content) {
    let direction;
    let $btnRemove = content.$.find('.cloud-edit-content .btn-remove');
    let $tpl;

    $tpl = jQuery(tpl());

    direction = ($btnRemove.offset().left + 200 + 20) < jQuery('body').outerWidth() ? 'left' : 'right';

    let popin = PopinManager.createPopin({
      'classes': {
        'ui-dialog': 'cloud-dialog cloud-dialog-popover remove-content cloud-dialog-popover-' + direction,
      },

        'width': 200,
        'modal': false,
        'minHeight': 100,
        'draggable': false,
        'appendTo': 'body',
        'position': {my: direction + ' bottom-15', at: direction + ' top', of: content.$},
        'buttons': [
            {
                class: 'popin popin-cancel',
                text: Translator.translate('discard'),
                click: function() {
                    Mediator.publish('overlay:click');
                },
            },
            {
                class: 'popin popin-ok',
                text: Translator.translate('delete'),
                click: function() {
                    ContentManager.remove(content);
                    popin.hide();

                    DndZone.apply();
                    ResizeColumn.apply();

                    SaveManager.save().done(function() {
                        Mediator.publish('after:content:remove', content);
                    });
                },
            },
        ],
    });

    popin.on('open', function() {
        Expose.disableUi();
        HighlightContent.start(content.$);

        content.$.find('.cloud-edit-content').children().each(function() {
            if (!jQuery(this).hasClass('cloud-right')) {
                jQuery(this).remove();
            }
        });
    });

    popin.on('close', function() {
        Expose.enableUi();
        HighlightContent.stop(content.$);
        content.$.find('.cloud-edit-content').remove();
    });

    popin.setContent($tpl);
    popin.rootElement.parent().append('<span class="arrow"></span>');

    content.addClass('fixed');

    popin.display();
};

module.exports.beforePopinOpen = function(config) {
  if (config.$popin.dialog('option', 'classes.ui-dialog').includes('remove-content')) {
        config.blur = false;
        config['reduce_opacity'] = true;
    }
};
